mutation RestoreEdition($id: ID!) {
    editionRestore(input: {id: $id}) {
        edition {
            id
        }
    }
}
